import React from 'react';
import PropTypes from 'prop-types';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMMessageSenderView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      reservation: this.props.reservation,
      message: this.props.message
    };
  }
  
  render() {
    let reservation = this.props.reservation,
        message = this.state.message,
        name = SMFormatHelper.messageName(message, reservation);
    let classNames = [
      "dashboard-message-baloon",
      "dashboard-message-baloon__right",
      "dashboard-message-baloon__send",
    ];
    let readStatus = message.is_read_by_other_side ? <p className="dashboard-message__read-status">既読</p> : null;
    
    return (
      <div className="dashboard-message-box">
        <img src={message.from.profile_image} className="dashboard-message__icon fr" alt={name} />
        {readStatus}
        <p className={classNames.join(" ")}
          dangerouslySetInnerHTML={{__html:SMFormatHelper.messageContent(message)}}>
        </p>
        {SMRenderHelper.renderFileAttachment(message, name)}
      </div>
    );
  }
}

SMMessageSenderView.propTypes = {
  reservation: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
};
export default SMMessageSenderView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageSenderView.jsx